import { Box, Flex, useResponsive } from '@ghq-abi/design-system';
import Image from 'next/image';
import Link from 'next/link';
import * as React from 'react';
import abInbevLogo from '~/../public/img/logo-ab-inbev.png';
import { useAbility } from '~/app/contexts/AbilityContext';
import { useFlags } from '~/app/contexts/FlagsContext';
import { MobileMenu } from '../Nav/components/MobileMenu';
import { StyledActionWrapper } from './styles';

type HomeLinkProps = {
  children: React.ReactNode;
};

function HomeLink({ children }: HomeLinkProps) {
  const flags = useFlags();

  const href = React.useMemo(() => {
    if (flags.home.active) {
      return '/home';
    }

    return null;
  }, [flags.home.active]);

  return href ? (
    <Link href={href} legacyBehavior passHref>
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
}

export function HeaderActions() {
  const ability = useAbility();

  const { isMobile } = useResponsive({ useOnlyAbiTokens: true });

  const LogoContainer = ability.can('view', 'Home') ? HomeLink : React.Fragment;

  return (
    <StyledActionWrapper>
      {(isMobile) && <MobileMenu />}
      <LogoContainer>
        <Flex
          align="center"
          gap="lg"
          as="a"
          css={{ textDecoration: 'none' }}
        >
          <Box>
            <Image src={abInbevLogo} alt="Ab InBev" placeholder="blur" />
          </Box>
          <Flex direction="column" css={{ gap: 0 }}>
            {(!isMobile) && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  lineHeight: '1.1',
                }}
              >
                <span
                  style={{
                    fontFamily: 'Avant bold, sans-serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#000000',
                    textAlign: 'left',
                  }}
                >
                  Compliance
                </span>
                <span
                  style={{
                    fontFamily: 'Avant bold, sans-serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#000000',
                    textAlign: 'left',
                  }}
                >
                  Channel
                </span>
              </div>
            )}
          </Flex>
        </Flex>
      </LogoContainer>
    </StyledActionWrapper>
  );
}
